import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c(VDialog,{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.msgshow),callback:function ($$v) {_vm.msgshow=$$v},expression:"msgshow"}},[_c(VCard,[_c(VCardTitle,{class:{
          'headline': true,
          'primary--text': !_vm.$vuetify.theme.dark,
          'foreground--text': !_vm.$vuetify.theme.dark,
        },staticStyle:{"box-shadow":"1px 1px 5px 3px color-mix(in srgb, var(--v-shadow-base) 50%, transparent)"}},[_vm._v("\n        "+_vm._s(_vm.getTitle())+"\n      ")]),_c(VCardText,{staticClass:"pt-5"},[_c('p',{staticStyle:{"font-size":"16px !important"},domProps:{"innerHTML":_vm._s(_vm.msg.data.text)}})]),_c(VCardActions,{staticStyle:{"justify-content":"center"}},[_c(VBtn,{staticClass:"btn-quote",on:{"click":function($event){return _vm.hidemsg()}}},[_vm._v("OK")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }